import { Box } from '@factorialco/deprecated-design-system'

import { PdfViewer } from 'modules/ats/components/PdfViewer'

interface Props {
  url: string
  filename: string
}

export const OfferLetterFromTemplateFilePreview = ({
  url,
  filename,
}: Props): React.ReactElement => {
  return (
    <Box
      flexGrow
      height="full"
      overflowY="auto"
      background="grey100"
      width="full"
      alignItems="center"
    >
      <Box height="full" style={{ width: '80%' }}>
        <PdfViewer url={url} filename={filename} initialScale="page-width" />
      </Box>
    </Box>
  )
}
